export type SocialMedia = {
    name: string
    url: string
    src: string
}

export const SOCIAL_MEDIA: SocialMedia[] = [
    {
        name: 'Telegram',
        url: 'https://t.me/playblockpot',
        src: '/assets/svgs/social/telegram.svg'
    },
    {
        name: 'Instagram',
        url: 'https://www.instagram.com/playblockpot',
        src: '/assets/svgs/social/instagram.svg'
    },
    {
        name: 'TikTok',
        url: 'https://www.tiktok.com/@playblockpot',
        src: '/assets/svgs/social/tiktok.svg'
    },
    {
        name: 'X',
        url: 'https://x.com/playblockpot',
        src: '/assets/svgs/social/x.svg'
    }
]